import React from 'react';

import WP_API from '../apis/wp-api';


class Success extends React.Component{

    _inputRef  = React.createRef();


    state = {
        shareUrl: null,
        copySuccess: null
    }


    shareStart = async ()=> {

            if(this.state.shareUrl) return;

        await WP_API.post('share/', {
            data: this.props,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'Token'
            }
        })
        .then(response => {
            console.log(response.data);
            this.setState({
                shareUrl: 'https://' + window.location.hostname + '/share/results/?gd=' + response.data.unique_str
            });
        })
        .catch(error => {
            console.log(error);
        });
    }


    selectAll =(evt)=>{

        this._inputRef.current.select();
        
            if(typeof document.execCommand !== 'function') return;

        document.execCommand('copy');
        this.setState({
            copySuccess: 'Copied!'
        });
    }


    render(){

        console.log('shareUrl', this.state.shareUrl);

        const shareElement = (this.state.shareUrl ? <div id="shareElement">{(this.state.copySuccess ? <span>{this.state.copySuccess}</span> : '')}<label htmlFor="inputField">Copy and share:</label><input id="inputField" name="inputField" ref={this._inputRef} onClick={this.selectAll} onBlur={()=>this.setState({copySuccess: null})} type="text"value={this.state.shareUrl} autoFocus readOnly /></div> : '');

        return(
            <section id="pageSuccess" className="page-content">
                <h2>GAME OVER</h2>
                <div className="page-content-header"><i className="material-icons g-icon-huge">verified_user</i></div>
                <p>You finished {this.props.mission_length} tasks, scoring <strong>{this.props.points_total}</strong> points of {this.props.points_max_total}!</p>
                <p>Success rate: {this.props.success_rate}%</p>
                {shareElement}
                <div className="g-row g-flex g-text-center">
                    <div className="g-col">
                        <h3>Share your result</h3>
                        <p>And challenge a friend!</p>
                        <button onClick={this.shareStart} className="btn btn-secondary g-mx-auto">Share<i className="material-icons g-right">share</i></button>
                    </div>
                    <div className="g-col">
                        <h3>See all games</h3>
                        <p>All coloVR games in one place.</p>
                        <a className="btn btn-secondary g-mx-auto" href="https://colovr.com/games/">All games<i className="material-icons g-right">keyboard_arrow_right</i></a>
                    </div>
                </div>
            </section>
        )
    }
}


export default Success;